import { render } from "./BackLastPage.vue?vue&type=template&id=9481e908&scoped=true"
import script from "./BackLastPage.vue?vue&type=script&lang=js"
export * from "./BackLastPage.vue?vue&type=script&lang=js"

import "./BackLastPage.vue?vue&type=style&index=0&id=9481e908&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9481e908"]])

export default __exports__